import { render, staticRenderFns } from "./BuyersAndRegions.vue?vue&type=template&id=246db29e&scoped=true"
import script from "./BuyersAndRegions.vue?vue&type=script&lang=ts"
export * from "./BuyersAndRegions.vue?vue&type=script&lang=ts"
import style0 from "./BuyersAndRegions.vue?vue&type=style&index=0&id=246db29e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246db29e",
  null
  
)

export default component.exports